import React, { FC } from "react";
import { Select } from "antd";
import { DisplayMode } from "./helper";

interface Props {
  displayMode: DisplayMode;
  setDisplayMode: (mode: DisplayMode) => void;
}

const DisplayModeSelector: FC<Props> = ({ displayMode, setDisplayMode }) => (
  <div style={{ marginBottom: '16px' }}>
    <label style={{ marginRight: '12px', fontWeight: 600, fontSize: '15px', color: '#374151' }}>
      Display Mode:
    </label>
    <Select
      value={displayMode}
      onChange={(value) => setDisplayMode(value as DisplayMode)}
      style={{ width: 160, height: 40 }}
      size="large"
    >
      {Object.entries(DisplayMode).map(([key, value]) => (
        <Select.Option value={value} key={key}>
          <span style={{ fontSize: '15px' }}>{value}</span>
        </Select.Option>
      ))}
    </Select>
  </div>
);

export default DisplayModeSelector;
